/**
 * Acronym map used for label/title-casing throughout the marketing surfaces.
 * Phase 6 — surfaces "AI" instead of "Ai" in capitalised category labels, etc.
 */
const ACRONYMS: Record<string, string> = {
  ai: "AI",
  api: "API",
  saas: "SaaS",
  b2b: "B2B",
  b2c: "B2C",
  kpi: "KPI",
  cmo: "CMO",
  cto: "CTO",
  cfo: "CFO",
  ceo: "CEO",
  mvp: "MVP",
  seo: "SEO",
  faq: "FAQ",
  ux: "UX",
  ui: "UI",
};

/** Title-case a single word, then apply the acronym override if any. */
function fixWord(w: string): string {
  if (!w) return w;
  const lower = w.toLowerCase();
  if (ACRONYMS[lower]) return ACRONYMS[lower];
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

/**
 * Format a category-style label: split on whitespace + hyphens, title-case each
 * word, and force known acronyms (AI, API, SaaS, …) to canonical casing.
 */
export function formatCategoryLabel(input: string | null | undefined): string {
  if (!input) return "";
  return input
    .split(/(\s+|-)/)
    .map((tok) => (/^\s+$/.test(tok) || tok === "-" ? tok : fixWord(tok)))
    .join("");
}
